import Funcs from 'common/helpers/Funcs';
import { getTrackingStatus, requestTrackingPermission } from 'react-native-tracking-transparency';
import StorageService from './StorageService';

export default {
  init: async () => {
    try {
      let trackingStatus = await getTrackingStatus();
      if (trackingStatus === 'authorized' || trackingStatus === 'unavailable') return;
      const key = 'TRACKING';
      var rated = await StorageService.get(key);
      if (rated) return;
      trackingStatus = await requestTrackingPermission();
      if (trackingStatus === 'authorized' || trackingStatus === 'unavailable') {
      }
      StorageService.save(key, true);
    } catch (err) {
      Funcs.log(err);
    }
  }
};
